import type { Iti } from 'intl-tel-input'

export const phoneRule = (value: string, [itiGetter] = [() => undefined as unknown as Iti]) => {
  if (value.trim() === '') return true

  if (!itiGetter) return 'Internal error: intl-tel-input is not initialized'
  const itiValue = itiGetter()
  if (!itiValue) return 'Internal error: intl-tel-input is not initialized'
  return !!itiValue.isValidNumberPrecise()
}
